import { Col, Container as ReactstrapContainer, Row as ReactstrapRow } from 'reactstrap';
import styled, { css } from 'styled-components';

import Button from 'src/app/components/Elements/Button';

/*
  Layout Styles
 */

export const OnboardingContainer = styled(ReactstrapContainer)`
  max-width: 100%;
  min-height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
`;

export const MainRow = styled(ReactstrapRow)`
  flex: 1 1 auto;
  padding-bottom: ${props => (props.smallBottomPadding ? props.theme.space['3.4'] : props.theme.space['14.4'])};
  padding-bottom: ${props => props.isSubpage && props.theme.space.none};
  ${props => props.theme.mediaQueries.medium} {
    flex-wrap: nowrap;
    padding-top: ${props => props.theme.space['7.2']};
  }

  justify-content: ${props => (props.centerContent ? 'center' : '')};
`;

export const FooterRow = styled(ReactstrapRow)`
  padding: 0 ${props => props.theme.space.s7} ${props => props.theme.space.s5};
  ${props => props.theme.mediaQueries.mediumDown} {
    padding: ${props => props.theme.space.none} ${props => props.theme.space.s7} ${props => props.theme.space.s7};
  }
`;

export const MainSection = styled.div`
  ${props => props.theme.mediaQueries.medium} {
    max-width: 50.5rem;
    overflow: visible;
  }
  padding-left: ${props => props.theme.space.none};
  padding-right: ${props => props.theme.space.none};
  height: 100%;
  width: 100%;
`;

export const Container = styled.div`
  width: 100%;
  position: relative;
`;

export const Content = styled.div<{ isPharmacyStep: boolean }>`
  display: flex;
  height: 100%;
  padding: ${props => props.theme.space.s7}
    ${props => (props.isPharmacyStep ? props.theme.space.s5 : props.theme.space.s7)} 0;
  ${props => props.theme.mediaQueries.medium} {
    padding: ${props => props.theme.space.none};
  }
`;

/*
  Form Styles
 */

export const FormContainer = styled.div`
  margin-top: ${props => props.theme.space.s5};

  ${props => props.theme.mediaQueries.medium} {
    margin-top: ${props => props.theme.space.s7};
  }
`;

export const StyledSpinnerContainer = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  min-height: 50vh;
  width: auto;
  top: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: 150px;
`;

/*
  Progress Bar Styles
 */

export const Sidebar = styled(Col)`
  height: 0.5rem !important;
  position: fixed;
  width: 100vw;
  z-index: ${props => props.theme.zIndices.topOne};
  padding: ${props => props.theme.space.none} !important;

  ${props => props.theme.mediaQueries.medium} {
    padding: ${props => props.theme.space.none} ${props => props.theme.space.s7} !important;
    min-width: ${props => (props.isEmpty ? 'none' : props.theme.space['24.0'])};
    height: auto !important;
    position: relative;
  }
`;

/*
  Body Text Styles
 */

export const StyledSubtitle = styled.span<{ maxWidth?: number }>`
  ${props => props.theme.mediaQueries.medium} {
    max-width: ${props => (props.maxWidth ? props.maxWidth : 58)}rem;
  }
  display: block;
`;

export const AnimatedFadeInOutText = styled.span<{ isFadedIn: boolean }>`
  ${props =>
    props.isFadedIn &&
    css`
      animation-name: ${props.theme.animations.fadeIn};
      animation-duration: ${props.theme.animationDurations[750]};
    `}
`;

export const StyledSuccessMessage = styled.div`
  font-size: ${props => props.theme.fontSizes.small};
  font-weight: ${props => props.theme.fontWeights.semiBold};
  line-height: ${props => props.theme.lineHeights.small};
  color: ${props => props.theme.colors.capsuleGray50};
  margin-top: ${props => props.theme.space['1.0']};
`;

export const EmptyHeight = styled.div`
  margin-top: ${props => props.theme.space['1.0']};
  height: 1.8rem;
`;

/*
  Button Styles
 */

export const ButtonContainer = styled.div<{ smallMarginTop?: boolean }>`
  margin-top: ${props => (props.smallMarginTop ? props.theme.space['4.0'] : props.theme.space['7.2'])} !important;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  ${props => props.theme.mediaQueries.mediumDown} {
    flex-direction: column;
  }
`;

export const StyledButton = styled(Button)<{ isHiddenForMobile?: boolean }>`
  margin-right: ${props => props.theme.space.s5};
  border-radius: ${props => props.theme.radii.small};
  width: 24rem;

  ${props => props.theme.mediaQueries.extraLargeDown} {
    display: ${props => (props.isHiddenForMobile ? 'none' : '')};
    width: 100%;
    margin-right: ${props => props.theme.space.none};
  }
`;

export const StyledSingleButton = styled(Button)<{ isHiddenForMobile: boolean }>`
  border-radius: ${props => props.theme.radii.small};
  width: 24rem;

  ${props => props.theme.mediaQueries.extraLargeDown} {
    display: ${props => (props.isHiddenForMobile ? 'none' : '')};
    width: 100%;
  }
`;

/*
  Styled Step Count Components
*/

export const MobilePreviousButton = styled.button`
  display: flex;
  align-items: center;
  background: none;
  border: none;
  margin-right: ${props => props.theme.space['1.0']};
  color: ${props => props.theme.colors.capsuleGreen60};
  font-weight: ${props => props.theme.fontWeights.book};
  line-height: ${props => props.theme.space['2.0']};
  font-family: ${props => props.theme.fonts.circular};
  font-size: ${props => props.theme.fontSizes.body} !important;
  cursor: pointer;
`;

export const StyledStepCount = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${props => props.theme.space['2.1']};
  color: ${props => props.theme.colors.capsuleBlue50};
  font-weight: ${props => props.theme.fontWeights.book};
  line-height: ${props => props.theme.space['2.0']};
  font-family: ${props => props.theme.fonts.circular};
  font-size: ${props => props.theme.fontSizes.body} !important;
  & > p {
    font-weight: ${props => props.theme.fontWeights.semiBold} !important;
  }
`;

export const LargeSubtitle = styled.div`
  font-family: ${props => props.theme.fonts.circular};
  font-size: ${props => props.theme.fontSizes.body};
  line-height: ${props => props.theme.lineHeights.body};
  color: ${props => props.theme.colors.capsuleBlue50};
`;

// Ideally, this component would be an extension of the GraySubtitle component, however, as with several styled
// components throughout the code base, extending a base component has not worked in this instance.
export const LegalMessage = styled.div`
  font-size: ${props => props.theme.fontSizes.small};
  color: ${props => props.theme.colors.capsuleGray50};
  margin-top: ${props => props.theme.space.s3};
  line-height: ${props => props.theme.lineHeights.small};
  svg {
    fill: ${props => props.theme.colors.capsuleGray50};
  }
`;

export const AutoCompleteMenuItemName = styled.span`
  margin: ${props => props.theme.space.none} ${props => props.theme.space.none} ${props => props.theme.space.s1};
  display: block;
`;

export const AutoCompleteMenuItemMeta = styled.span`
  display: block;
  font-size: ${props => props.theme.fontSizes.small};
  font-weight: ${props => props.theme.fontWeights.semiBold};
  line-height: ${props => props.theme.lineHeights.small};
`;

export const BoldSubheader = styled.div`
  font-weight: ${props => props.theme.fontWeights.bold};
  margin-bottom: ${props => props.theme.space.s3};
`;

export const OrderedList = styled.ol`
  list-style-position: inside;
`;

export const IndentedListItem = styled.li`
  &:before {
    content: '';
    margin-right: ${props => props.theme.space.s1};
  }
`;

/*
  Get Early Access Step
*/
export const StepCountHeight = styled.div`
  height: ${props => props.theme.lineHeights.body};
  margin-bottom: ${props => props.theme.space.s2};
`;

export const StepContainer = styled.div`
  width: 100%;
`;

/*
  Enhanced Pharmacy Step
*/
export const ToggleContainer = styled.div`
  width: 24rem;
  height: 3rem;
  border: 0.1rem solid ${props => props.theme.colors.capsuleGreen60};
  border-radius: ${props => props.theme.radii.small};
  margin-top: ${props => props.theme.space.s5};
  margin-bottom: ${props => props.theme.space.s5};
  ${props => props.theme.mediaQueries.smallDown} {
    width: 100%;
  }
`;

export const MapContainer = styled.div<{ toggleShow: boolean }>`
  min-height: 36rem;
  margin-top: ${props => props.theme.space.s7};
  width: 100%;
  ${props => props.theme.mediaQueries.smallDown} {
    margin-left: calc(50% - 50vw);
    width: 100vw;
  }
  ${props => (props.toggleShow ? 'display: block;' : 'display: none;')}
`;

export const ListContainer = styled.div<{ toggleShow: boolean }>`
  width: 100%;
  ${props => (props.toggleShow ? 'display: block;' : 'display: none;')}
`;

export const ListItem = styled.button<{ isSelected: boolean }>`
  background: none;
  font: inherit;
  display: flex;
  flex-direction: row;
  cursor: pointer;
  align-items: center;
  color: ${props => (props.isSelected ? props.theme.colors.capsuleGreen60 : props.theme.colors.capsuleGray50)};
  padding: ${props => props.theme.space.s5} ${props => props.theme.space.none};
  width: 100%;
  border-top: none;
  border-right: none;
  border-left: none;
  :focus {
    outline: none;
  }
  border-bottom: 1px solid
    ${props => (props.isSelected ? props.theme.colors.capsuleGreen60 : props.theme.colors.capsuleGray10)};
`;

export const ListTextContainer = styled.div`
  text-align: left;
`;

export const ListText = styled.div`
  font-size: ${props => props.theme.fontSizes.body};
  margin-bottom: ${props => props.theme.space['0.3']};
  line-height: ${props => props.theme.lineHeights.body};
`;

export const ListSubText = styled.div`
  font-size: ${props => props.theme.fontSizes.small};
  font-weight: ${props => props.theme.fontWeights.semiBold};
  line-height: ${props => props.theme.lineHeights.small};
`;

export const ListNumber = styled.div`
  font-size: ${props => props.theme.fontSizes.headerThree};
  font-weight: ${props => props.theme.fontWeights.semiBold};
  margin-right: ${props => props.theme.space['3.0']};
  width: ${props => props.theme.space['2.0']};
  text-align: left;
`;

export const CheckIconContainer = styled.div`
  width: 3rem;
  height: 2rem;
  padding-left: ${props => props.theme.space['1.0']};
  margin-right: ${props => props.theme.space.none};
  margin-left: auto;
  fill: ${props => props.theme.colors.capsuleGreen60};
  flex: none;
`;

export const GoogleRecaptchaDisclaimerContainer = styled.div`
  color: ${props => props.theme.colors.capsuleGray10};
  display: flex;
  flex-direction: row;
  font-size: ${props => props.theme.fontSizes.small};
  margin-left: auto;
  align-items: center;
`;

export const GoogleRecaptchaIcon = styled.div`
  svg {
    fill: ${props => props.theme.colors.capsuleGray10};
    stroke: ${props => props.theme.colors.capsuleGray10};
    width: 2.4rem;
    height: 2.4rem;
  }
  margin-right: ${props => props.theme.space.s2};
`;

export const GoogleRecaptchaText = styled.div``;
